import { render } from "./B2bLoginPasswordFormUfgas.vue?vue&type=template&id=3f1cd6bd&scoped=true&lang=pug"
import script from "./B2bLoginPasswordFormUfgas.vue?vue&type=script&lang=js"
export * from "./B2bLoginPasswordFormUfgas.vue?vue&type=script&lang=js"

import "./B2bLoginPasswordFormUfgas.vue?vue&type=style&index=0&id=3f1cd6bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1cd6bd"]])

export default __exports__